/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br."Knowledge
 * for Decisions (K4D)" and the slogan"Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import React from'react';
import { cn } from'@/shared/ui/utils/tailwind';
import {
  useFormStoreFieldError,
  useFormStoreFieldState,
} from'../FormStore';

type Props = {
  name?: string;
  label?: string;
  children?: React.ReactNode;
  className?: string;
  [key: string]: any;
};

/**
 * Form field label that changes style based on focus and error state.
 *
 * When`name` is provided the label binds to the form store (focus/error
 * styling and`htmlFor`). When omitted it renders as a plain styled label.
 *
 * @param {Props} props - Label properties.
 * @returns {JSX.Element} Rendered label.
 */
const Label: React.FC<Props> = ({
  name,
  label,
  children,
  className,
  ...props
}) => {
  const fieldState = useFormStoreFieldState(name ??'');
  const fieldError = useFormStoreFieldError(name ??'');
  const hasRealError = fieldError !== undefined && fieldError !=='__REQUIRED__';

  return (
    <label
      htmlFor={name}
      className={cn(
        'text-sm leading-tight',
        fieldState.isFocused &&'text-[var(--seed-base)] font-semibold',
        hasRealError &&'text-[var(--status-error-text)]',
        className
      )}
      {...props}
    >
      {children ?? label}
    </label>
  );
};

export default Label;
